import PropertyControl from './PropertyControl';

export default PropertyControl;
